export default class MissingDiamondError extends Error {
};
